import React, { useState, useEffect, useContext, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import { Button } from "react-bootstrap";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import localization from 'assets/localization/localization';
import Images from "assets/images/imageData";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import ChangeLobStatus from "../ChangeLobStatus";
import ListFilters from "components/sales/ListFilters/ListFilters";

const LobListing = ({
    getLobListing,
    lobList = [],
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const { baseUrl } = useContext(BaseUrl);
  const [showLobChangeStatus, setShowLobChangeStatus] = useState(false);
  const [selectedLob, setSelectedLob] = useState(null);
  const [lobCurrentStatus, setLobCurrentStatus] = useState(null);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedFilterLob, setSelectedFilterLob] = useState(false);
  const [selectedLobCode, setSelectedLobCode] = useState(false);
  const [selectedDimension, setSelectedDimension] = useState(false);

  const headers = [
    "Name",
    "Dim. Value Type",
    "Totaling",
    "ERP Code",
    "Status",
    "Action",
  ];

  useEffect(() => {
    (async () => {
        try {
        setIsLoading(true);
        await getLobListing(null, 1, null);
        } catch (error) {
        console.error("Error fetching LOB list:", error);
        } finally {
        setIsLoading(false);
        }
    })();
  }, []);
  
  useEffect(() => {
    if (!lobList || !lobList?.resultSets) return;
  
    let tableData = [];

      tableData = [
        "name",
        "dimension_value_type",
        "show_totaling",
        "erp_code",
        "lob_status",
      ];
  
    const data = lobList.resultSets.map((element) => {
      let actions = [
          {
            'name' : 'Edit LOB',
            'link' : `${baseUrl}/edit-lob/${element.id}` 
          },
          {
            name: "Change LOB Status",
            id: element.id,
            status: element.status
          },
      ];
  
      return {
        ...Object.fromEntries(tableData.map(key => [key, element[key]])),
        Action: actions
      };
    });
  
    data && setListData(data);
    setPageCount(Math.ceil(lobList?.total / (lobList?.per_page)));
  
  }, [lobList]);     

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getLobListing(filterData, val.selected + 1);
    setIsLoading(false);
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    localStorage.setItem("lob_filter", JSON.stringify(filterData));
    setListData([])
    setIsLoading(true);
    setFilterData(filterData);
    console.log("Filter Data: " + JSON.stringify(filterData));
    await getLobListing(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  const headerBtns = () => {
    return (
      <>
        <Fragment>
          <Button
            onClick={filterToggle}
            className="filter-hamburger btn btn-transparent"
          >
            <img src={Images?.Filter} alt=""></img>
            {localization.showFilters}
          </Button>
        </Fragment>
        <Fragment>
          <a
            href={`/dashboard/add-lob`}
            className="filter-hamburger btn btn-primary borderColorBox colorBox filterButton"
          >+ Add LOB
          </a>
        </Fragment>
      </>
    );
  };

  return (
    <>
        <Layout
        title="Lob Listing"
        Buttons={headerBtns}
        className={false ? "requiredFileds" : ""}
        isLoading={isLoading}
        >
            <TableSection
                data={listData}
                headers={headers}
                pageCount={pageCount}
                onPageChange={onPageChange}
                setShowLobChangeStatus={setShowLobChangeStatus}
                setSelectedLob={setSelectedLob}
                setLobCurrentStatus={setLobCurrentStatus}
            />
            <ListFilters
              showFilter={showFilter}
              filterToggle={filterToggle}
              applyFilter={(val) => applyFilter(val)}
              lobFilter
              setSelectedLobCode={setSelectedLobCode}
              setSelectedDimension={setSelectedDimension}
              setSelectedFilterLob={setSelectedFilterLob}
            />
            <ChangeLobStatus
              showLobChangeStatus={showLobChangeStatus}
              selectedLob={selectedLob}
              lobCurrentStatus={lobCurrentStatus}
              onClosePopup={() => setShowLobChangeStatus(false)}
            />
        </Layout>
    </>
  );
};

export default LobListing;
